<head>
    <style>
        .my-pagination /deep/ .ngx-pagination .current {
            font-family: "Graphik SemiBold";
            font-weight: normal;
            font-style: normal;
            font-display: swap;
            color: #265d6e;
            background: transparent;
        }
    </style>
</head>
<div class="container-fluid">
    <nav class="navbar navbar-light sub-nav">
        <div class="alert-row">
            <app-alert-message *ngIf="isDisplayAlert" (closeClick)="alertClose()" [message]="message" [messageType]="messageType"></app-alert-message>
        </div>
        <div class="left-nav">
            <a class="navbar-brand">
                <h5 class="Ws-subtitle">{{title}}</h5>
            </a>
            <div style="margin: 0 10px;">
                <div class="wrapper">
                  <div class="filterButtonWrapper1" [ngClass]="isDropDownOpen ? 'bottom-line':''" (click)="toggleCheckboxVisibility()"><button class="filter">Filters <span *ngIf="!isDropDownOpen && (selectedCount > 0)"> ({{selectedCount}} selected)</span></button><span *ngIf="!isDropDownOpen">&#9660;</span><span *ngIf="isDropDownOpen">&#9650;</span></div>
            
                  <div class="checkboxes" id="Filters" *ngIf="isDisplayFilterDropDown">
                    <label *ngFor="let item of filterCheckboxLabels" class="checkboxWrapper">
                      <span class="p-l-16">{{item}}</span>
                          <input type="checkbox"  (change)="checkValue($event,item)" [(ngModel)]="selectedCheckboxes[item]" class="ckkBox val" />
                          <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
            </div>

            <div style="margin: 0 10px;" *ngIf="title == 'All Videos'">
                <div class="wrapper">
                    <div class="search-text">
                        <input class="search" type="text" placeholder="Search" [(ngModel)]="searchQuery" >
                    </div>
                </div>
            </div>

            <div style="margin:0 10px;">
                <div class="wrapper">
                    <div class="filterButtonWrapper2" [ngClass]="isDropDownOpen1 ? 'bottom-line':''" (click)="toggleVisibility()" ><button class="filter">Sort by <span *ngIf="!isDisplayDropDown">({{selectedSortOption}})</span></button><span *ngIf="!isDropDownOpen1">&#9660;</span><span *ngIf="isDropDownOpen1">&#9650;</span></div>
                </div>
                <ng-container *ngIf="title == constants.UPLOADED_VIDEOS_TITLE;else curatedtemplate">
                    <div class="checkboxes2" id="sorts" *ngIf="isDisplayDropDown">
                        <label *ngFor="let item of sortByOptions" class="checkboxWrapper">
                          <span class="p-l-16">{{item.value}}</span>
                              <input type="radio"  [value]="item.value"(change)="checkSortValue($event,item)"  [(ngModel)]="selectedSortOption" class="ckkBox val" />
                              <span class="checkmark"></span>
                        </label>
                    </div>
                </ng-container>
                <ng-template #curatedtemplate>
                    <div class="checkboxes2" id="sorts" *ngIf="isDisplayDropDown">
                        <label *ngFor="let item of sortByCuratedOptions" class="checkboxWrapper">
                          <span class="p-l-16">{{item.value}}</span>
                              <input type="radio"  [value]="item.value"(change)="checkSortValue($event,item)"  [(ngModel)]="selectedSortOption" class="ckkBox val" />
                              <span class="checkmark"></span>
                        </label>
                    </div>
                </ng-template>
               
            </div>
            <div>
            </div>
            <span  class="navbar-text searchIcon" (click)="isLoading ? null : SearchWithFilters()">
                <img src="{{constants.MAP_SEARCH_MOBILE}}"/>
            </span>
            
            <span *ngIf="isFiltersApplied" class="navbar-text close-icon" (click)="clearFilters()">
                <img src="{{constants.CLOSE_IMG}}"/>
            </span>
        

            <button *ngIf="isCurated" (click)="onClickCurate(false)" class="button-generate" [disabled]="videoList?.length === 0 ?true:false || isLoading">
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{constants.UNCURATE_SELECTED_TXT}}</button>    

                <button *ngIf="isCurated" (click)="toggleFreeVideo()" class="button-generate" [disabled]="videoList?.length === 0 ?true:false || isLoading">
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    {{constants.TOGGLE_FREE_VIDEO_TXT}}
                </button>    
        
        </div>   
        <div class="right-nav">
            <button (click)="paginateLoad()" type="button" class="button-generate" [disabled]="startKey === undefined || isLoading || !(totalCount >curatedVideos?.length)||isDisableLoadMore">
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Load More
            </button>
            <a [routerLink]="['/admin/curated/1']">
                <p id="non-curated-button" class="curated-buttons" [ngClass]="isCurated ? '':'curated-buttons-active'">{{constants.NON_CURATED_VIDEOS_TEXT}}</p>
            </a>
            <a [routerLink]="['/admin/curated']">
                <p id="cuarted-button" class="curated-buttons" [ngClass]="isCurated ? 'curated-buttons-active':''">
                    {{constants.CURATED_VIDEO_TXT}}
                </p>
            </a>
           
       
            <!-- <span class="navbar-text justify-content-end">
                <input id="search" class="search" type="text" placeholder="search" (ngModelChange)="Search()" [(ngModel)]="searchQuery">
            </span> -->
        </div> 
    </nav>
    <div class="row uploaded-window" *ngIf="isLoading">
        <div *ngFor="let item of uploadSkeltonArray" class="col-3 uploaded-window-col">
            <img style="width: 100%;" src="{{item}}" alt="">
        </div>
    </div>
    <div class="row uploaded-window" *ngIf="!isLoading">
        <div id="empty" class="error w-100" *ngIf="curatedVideos?.length === 0">List is empty</div>
        <div class="col-3 uploaded-window-col" id="{{item.videoId}}-card"
            *ngFor="let item of curatedVideos| paginate: { itemsPerPage: pageSize, currentPage: pageNumber}">
            <div class="card uploaded-card">
                <div class="card-body uploaded-card-body row">
                    <div class="col uploaded-card-img-container">
                        <input *ngIf="title !== 'All Videos'" class="card-checkbox" type="checkbox" [checked]="item.isChecked" id="{{item.videoId}}-live"
                            (change)=onSelectTbleRow(item,$event) >
                        <span *ngIf="title === 'All Videos' && item.isCurated === constants.CURATION_STATUS.curated" class="curation-status-indicator">
                            <img src="https://cdn-icons-png.flaticon.com/512/14090/14090371.png" width="25" height="25" alt="" title="" class="img-small">
                        </span>
                        <span *ngIf="title === 'All Videos' && item.isCurated === constants.CURATION_STATUS.pending" class="curation-status-indicator flex-center">
                            <span class="spinner-border spinner-border-sm"  role="status" aria-hidden="true"></span>
                        </span>
                        <span *ngIf="title === 'All Videos' && item.isCurated === constants.CURATION_STATUS.failed" class="curation-status-indicator">
                            <img src="https://cdn-icons-png.flaticon.com/512/14090/14090276.png" width="25" height="25" alt="" title="" class="img-small">
                        </span>
                        <label class="bookmark-container" for="{{item.videoId}}-live"><img (click)="onClickVideoThumbnail(item,$event)" class="uploaded-card-img " src="{{item.thumbnail}}" alt="">
                            <div class="fs-10 curate-btn" (click)="onClickCurate(true,item.videoId)" *ngIf=" (!item.isCurated || item.isCurated === constants.CURATION_STATUS.failed) && (title == 'All Videos')">curate</div>

                            <div class="fs-10 paid-free-btn" *ngIf="(item.isCurated && title == 'Curated Videos' && item.isFreeForApp)">
                                <span> Free video</span>
                            </div>
                        </label>
                        <!-- Below lines is to show tags in UI for testing -->
                        <!-- <div class="tagcontainer">
                            <ng-container *ngFor="let tag of filterCheckboxLabels">
                                <span class="fs-10 c-tag" *ngIf="item[tag] == true">{{tag}}</span>
                            </ng-container>
                        </div>         -->
                        
                    </div>
                    <div class="col uploaded-card-title-container">
                        <div class="upload-card-title">
                            <p class="uploaded-title" (click)="onClickVideoTitle(item,$event)" id="{{item.videoId}}">
                                {{item.cityLocation}}</p>
                        </div>
                        <p class="upload-card-view">{{item.stats}} views </p>
                        <p class="upload-card-view">{{item.bookmarkCount}} bookmarked </p>
                        <p class="uploaded-card-duration">{{item.uploadedAtFormatted}}</p>
                        <p (click)="onClickName(item)" class="upload-card-author">{{item.author}}</p>
                        
                        <!-- <div class="fs-10 curated-tag" *ngIf="item.isCurated === constants.CURATION_STATUS.curated && (title == 'All Videos')">Curated</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <nav class="navbar navbar-priamry footer live-footer-curated" *ngIf="!isLoading&&(curatedVideos?.length > 0)">
        <pagination-controls class="my-pagination" (pageChange)="onPageChange($event)"></pagination-controls>
        <div class="count-display"  *ngIf="totalCount>0"><span>Total Windows: {{totalCount}}</span></div>
        <div class="count-display"  *ngIf="totalCount>0"><span>Total Free Windows: {{freeVideoCount}}</span></div>
    </nav>
</div>